export const EVAL_SCORES = Array.from({ length: 10 }, (_, i) => i + 1);
export const getEvalQuestions = (program) => (program?.questions || []).filter(q => q.evaluation_required);

// A question's raw evaluation_scores entry is either {judge_user_id: score} (current
// shape) or a bare number (legacy, pre-multi-judge, unattributed) — normalize both
// to a {judgeId: score} map so callers never branch on the shape themselves.
export const normalizeQScores = (raw) => {
  if (raw == null) return {};
  if (typeof raw === 'object') return raw;
  return { legacy: raw };
};

export const judgeName = (judgeId, teamMembersById = {}) => {
  if (judgeId === 'legacy') return 'Previous score';
  const m = teamMembersById[judgeId];
  return m?.full_name || m?.email || 'Unknown';
};

// {avg, scoredCount, totalCount, judgeCount, byJudge} across every question flagged
// for evaluation, or null if the program has none. `scores` is an app's (or details
// bundle's) evaluation_scores map. `avg` is the cumulative score across the whole
// judging team — the average of each judge's own average. `byJudge` is each judge's
// individual cumulative average, named via `teamMembersById` ({user_id: member}).
export const getCumulativeScore = (scores, evalQuestions, teamMembersById = {}) => {
  if (!evalQuestions.length) return null;
  const judgeIds = new Set();
  evalQuestions.forEach(q => {
    Object.keys(normalizeQScores((scores || {})[q.id])).forEach(jid => judgeIds.add(jid));
  });
  const byJudge = Array.from(judgeIds).map(judgeId => {
    const present = evalQuestions
      .map(q => normalizeQScores((scores || {})[q.id])[judgeId])
      .filter(s => s != null);
    return {
      judgeId,
      name: judgeName(judgeId, teamMembersById),
      avg: present.length ? Math.round((present.reduce((a, b) => a + b, 0) / present.length) * 10) / 10 : null,
      scoredCount: present.length,
    };
  }).sort((a, b) => a.name.localeCompare(b.name));
  const judgeAvgs = byJudge.map(j => j.avg).filter(v => v != null);
  const scoredCount = evalQuestions.filter(q => Object.keys(normalizeQScores((scores || {})[q.id])).length > 0).length;
  return {
    avg: judgeAvgs.length ? Math.round((judgeAvgs.reduce((a, b) => a + b, 0) / judgeAvgs.length) * 10) / 10 : null,
    scoredCount,
    totalCount: evalQuestions.length,
    judgeCount: byJudge.length,
    byJudge,
  };
};

